// src/components/common/ScrollToTopOnNavigate/ScrollToTopOnNavigate.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui fait défiler la fenêtre en haut de la page
 * à chaque changement de route (URL).
 */
function ScrollToTopOnNavigate() {
  const location = useLocation(); // Hook de React Router pour obtenir l'objet de localisation actuel

  useEffect(() => {
    // Fait défiler la page vers le haut en douceur
    // Cet effet se déclenchera à chaque fois que 'location.pathname' change.
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Pour un défilement doux
    });
  }, [location.pathname]); // Dépendance : l'effet se re-déclenche si le chemin de l'URL change

  // Ce composant ne rend aucun élément visuel, il gère uniquement un effet secondaire.
  return null;
}

export default ScrollToTopOnNavigate;
